import * as Actions from "../action/inspectionMission";

const initialState = {
    inspectorShiftTimeslotData: [], 
    loading:true
};

const inspectorShiftTimeslotReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_ALLINSPECTOR_SHIFT_TIMESLOT: {
            return {
              ...state,
              inspectorShiftTimeslotData: action.payload, 
              loading: false,
            };
          }
          case Actions.GET_ALLINSPECTOR_SHIFT_TIMESLOT_ERROR: {
            return {
              ...state,
              error: action.payload,
              loading: false,
            };
          }
          case Actions.ADD_INSPECTOR_SHIFT_TIMESLOT:
            return {
              ...state,
              inspectorShiftTimeslots: [...state.inspectorShiftTimeslots, action.payload],
            };
      default:
        return state;
    }
  };
  export default inspectorShiftTimeslotReducer;